module.exports = __webpack_public_path__ + "static/img/parallax5.9accb328.jpg";